import { render, staticRenderFns } from "./SpatialSpanTutorial.vue?vue&type=template&id=30c2853a&scoped=true&"
import script from "./SpatialSpanTutorial.vue?vue&type=script&lang=js&"
export * from "./SpatialSpanTutorial.vue?vue&type=script&lang=js&"
import style0 from "./SpatialSpanTutorial.vue?vue&type=style&index=0&id=30c2853a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c2853a",
  null
  
)

export default component.exports